import IMAGES from "./components/mainComponents/imagesModule";
export const initialState = [
  {
    icon: IMAGES.bictorBong,
    name: "Victor (bictor bong)",
    id: 0,
    clicked: false,
  },
  {
    icon: IMAGES.general,
    name: "狼将军 (general wolf)",
    id: 1,
    clicked: false,
  },
  {
    icon: IMAGES.jonie,
    name: "暖羊羊 (jonie)",
    id: 2,
    clicked: false,
  },
  {
    icon: IMAGES.oldHead,
    name: "慢羊羊 (slowy)",
    id: 3,
    clicked: false,
  },
  {
    icon: IMAGES.paddi,
    name: "懒羊羊 (paddi)",
    id: 4,
    clicked: false,
  },
  {
    icon: IMAGES.smarc,
    name: "智羊羊 (smarc)",
    id: 5,
    clicked: false,
  },
  {
    icon: IMAGES.sparky,
    name: "沸羊羊 (sparky)",
    id: 6,
    clicked: false,
  },
  {
    icon: IMAGES.tibbie,
    name: "美羊羊 (tibbie)",
    id: 7,
    clicked: false,
  },
  {
    icon: IMAGES.weslie,
    name: "喜羊羊 (weslie)",
    id: 8,
    clicked: false,
  },
  {
    icon: IMAGES.willie,
    name: "小灰灰 (willie)",
    id: 9,
    clicked: false,
  },
  {
    icon: IMAGES.wolffy,
    name: "灰太狼 (wolffy)",
    id: 10,
    clicked: false,
  },
  {
    icon: IMAGES.wolnie,
    name: "红太狼 (wolnie)",
    id: 11,
    clicked: false,
  },
];

// characters: [
//   {
//     icon: IMAGES.bictorBong,
//     name: "bictor bong",
//     id: 0,
//   },
//   {
//     icon: IMAGES.general,
//     name: "general",
//     id: 1,
//   },
//   {
//     icon: IMAGES.jonie,
//     name: "jonie",
//     id: 2,
//   },
//   {
//     icon: IMAGES.oldHead,
//     name: "old head",
//     id: 3,
//   },
//   {
//     icon: IMAGES.paddi,
//     name: "paddi",
//     id: 4,
//   },
//   {
//     icon: IMAGES.smarc,
//     name: "smarc",
//     id: 5,
//   },
//   {
//     icon: IMAGES.sparky,
//     name: "sparky",
//     id: 6,
//   },
//   {
//     icon: IMAGES.tibbie,
//     name: "tibbie",
//     id: 7,
//   },
//   {
//     icon: IMAGES.weslie,
//     name: "weslie",
//     id: 8,
//   },
//   {
//     icon: IMAGES.willie,
//     name: "willie",
//     id: 9,
//   },
//   {
//     icon: IMAGES.wolffy,
//     name: "wolffy",
//     id: 10,
//   },
//   {
//     icon: IMAGES.wolnie,
//     name: "wolnie",
//     id: 11,
//   },
// ],
// };
